import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { SocketRoute, WEBSOCKET_URL, FileReadRoute } from '../../constants/urlConstants';
import { Button, Divider, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import { commons } from '../../commons';
import ResizableContent from '../widgets/ResizableContent';
import AuthService from '../../service/AuthService';
import zIndex from '@mui/material/styles/zIndex';
import { Resizable } from 're-resizable';

const LogViewer = (props) => {
  const [lines, setLines] = useState([]);
  const [fileContent, setFileContent] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [width, setWidth] = useState(window.innerWidth-20);
  const [height, setHeight] = useState(170);
  const [isResizing, setIsResizing] = useState(false);

  const startResize = () => setIsResizing(true);
  const stopResize = () => setIsResizing(false);
  const resize = (e) => {
    if (isResizing) {
      setWidth(e.clientX);
      //setHeight(e.clientY);
    }
  };

  useEffect(() => {
    loadDefaults()
    //reloadLog1()
    return () => {
    };
  }, [props.logs]);

  const loadDefaults = () => {
    let content = localStorage.getItem("logs");
    let newLogs = localStorage.getItem("newLogs");
    const lines2 = newLogs ? newLogs.split('[') : [];
    let newLines = [...lines, ...lines2];
    setLines(newLines)
  }

  const clearLog = () => {
    setLines([])
    localStorage.setItem("logs", [])
  }
 

  return (
    <Resizable
    defaultSize={{
      width,height
    }}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        border: '1px solid black',
        position: 'relative',
        overflow: 'hidden',
        padding: 2,
        
      }}
      // onMouseMove={resize}
      // onMouseUp={stopResize}
      // onMouseLeave={stopResize}
    >
      <div style={{
        display: 'flex', flexDirection: 'row', justifyContent: 'center', 
        position: 'sticky', top: 0, zIndex: 1000, background: "#6082B6", color: 'white',
        padding:5
      }}>
        <Typography variant='subtitle1' style={{ padding: 2, justifyContent: 'flex-start' }}>&nbsp;&nbsp;Logs</Typography>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', flex: 1 }}>
          <Tooltip title={"Clear Logs"}>
            <DeleteIcon onClick={e => clearLog(e)}></DeleteIcon>

          </Tooltip>
        </div>

      </div>
      <Divider />
      <div
        // onMouseDown={startResize}

        style={{
          minHeight: 200, width: '100%',
          overflow: 'auto',
          height: '100%', backgroundColor: 'white',
          position: 'absolute',
          marginTop: '100',
          top: 40,
          bottom: 10,
          right: 0,
          padding: 5,
          marginBottom: '100'
        }}>
        {/* <Resizable
        style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}
          defaultSize={{
            width: 320,
            height: 200,
          }}
        >
        {lines.map((line, index) => (
                    <Typography key={index} style={{ textAlign: 'left', fontSize: '14px', color: "#3b3b3b", paddingLeft: 10 }} variant='body1'>{line}</Typography>
                  ))}
        </Resizable> */}
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
          {lines.map((line, index) => (
            <Typography key={index} style={{ textAlign: 'left', fontSize: '14px', color: "#3b3b3b", paddingLeft: 10 }} variant='body1'>{line}</Typography>
          ))}
        </div>
      </div>
    </Resizable >
  );
};

export default LogViewer;
